import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  downloadFromUrl(url: string, fileName: string) {
    const anchorElement = document.createElement("a");
    anchorElement.href = url;
    anchorElement.download = fileName ?? "";
    anchorElement.click();
    anchorElement.remove();
  }

  downloadFromBlob(blob: string, fileName: string) {
    const anchor = document.createElement('a');
    anchor.href = blob;
    anchor.download = fileName;
    anchor.click();

    // Clean up
    window.URL.revokeObjectURL(blob);
  }
}
